import React from "react";
import defapps from "../asset/drop-js-phising-on-windows/default-apps.png";
import cals from "../asset/drop-js-phising-on-windows/cals.png";
import generate from "../asset/drop-js-phising-on-windows/generate.png";
import server from "../asset/drop-js-phising-on-windows/server.png";
import listener from "../asset/drop-js-phising-on-windows/listener.png";
import payload from "../asset/drop-js-phising-on-windows/payload.png";
import victim from "../asset/drop-js-phising-on-windows/victim.png";
import visit from "../asset/drop-js-phising-on-windows/visit.png";
import getshell from "../asset/drop-js-phising-on-windows/get-shell.png";

class JsPhising extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <div className="header pb-4">
            <h1 className="font-PoppinsBold">
              Drop <span className="font-green">Javascript</span> Phising On
              Windows 😃.
            </h1>
            <span className="font-PoppinsBold mx-1 text-grey">08-01-2026</span>
          </div>
          <div className="nav-content shadow-sm p-3 mb-5">
            <h2 className="font-PoppinsBold">Opening</h2>
            <p className="text text-justify pb-2">
              Halo semuanya, kembali lagi ke blog saya, setelah perjalanan saya
              diakhir tahun 2025 ini, saya mengawali 2026 dengan lebih santai,
              tentu ada target yang saya set ditahun ini, tapi yang pasti saya
              akan lebih banyak explore dan belajar secara konsiten, tanpa
              memaksa tubuh saya untuk kerja lebih keras (takut mengalami
              burnout seperti ditahun sebelumnya).
            </p>
            <h2 className="font-PoppinsBold">Javascript</h2>
            <img
              src={
                "https://course-net.com/wp-content/uploads/2022/12/JavaScript-Thumbnail-1200-x-630.jpeg"
              }
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <p className="text text-justify pb-2">
              Oke sebelum kita masuk ke materi bagaimana kita bisa menjadikan
              javascript menjadi phising attack pada windows, lebih baik kita
              berkenalan dulu. JavaScript (JS) adalah bahasa pemrograman utama
              untuk membuat halaman web interaktif, memungkinkan fitur dinamis
              seperti animasi, pembaruan konten, dan menu tarik-turun, bekerja
              bersama HTML (struktur) dan CSS (gaya) sebagai tiga teknologi inti
              web, serta dapat digunakan untuk aplikasi web, seluler, bahkan
              backend dengan Node.js. Ini adalah bahasa skrip berbasis browser
              yang memungkinkan manipulasi konten halaman secara langsung untuk
              pengalaman pengguna yang kaya. (AI Generated), Pada intinya
              javascript biasanya digunakan untuk berjalan pada content web,
              namun tidak jarang juga javascript digunakan sebagai backend suatu
              aplikasi (programming logic backend).
            </p>
            <h2 className="font-PoppinsBold">
              Apakah Javascript bisa berjalan di OS Based ?
            </h2>
            <p className="text text-justify pb-2">
              Jawabannya Bisa, beberapa sistem operasi bisa merun javascript,
              langsung pada os based (contohnya pada windows) bisa menggunakan
              <a
                href="https://en.wikipedia.org/wiki/Windows_Script_Host"
                className="font-green text-decoration-none mx-1"
              >
                WSH (Windows Script Host)
              </a>{" "}
              suatu teknologi Microsoft yang memungkinkan eksekusi skrip seperti
              VBScript dan JScript untuk mengotomatisasi tugas administratif di
              Windows, dijalankan melalui wscript.exe (GUI) atau cscript.exe,
              pada intinya javascript bisa langsung terexecute dengan
              menggunakan wsh (nah maka dari itu attack vector ini disebut
              phising), pada intinya (user memiliki missconfig yang mana menset
              js, default run dengan wsh) (hal ini terjadi pada windows version
              10, beberapa default version windows 10 menset bawa js memiliki
              program default dengan wsh).
            </p>
            <img src={defapps} className="img-fluid pb-1" alt="Responsive" />
            <p className="text text-justify pb-2">
              Pada case ini jika user (victim menset js di run, dengan wsh,
              tentu ini akan terexecute jika victim mentrigger file tersebut.)
            </p>
            <h2 className="font-PoppinsBold">Bagaimana phising dilakukan ?</h2>
            <p className="text text-justify pb-2">
              Setelah victim melakukan kesalahan misconfig diatas, attacker
              dapet memanfaatkan salah satu teknologi yang ada pada microsoft
              yaitu
              <a
                href="https://en.wikipedia.org/wiki/ActiveX"
                className="font-green text-decoration-none mx-1"
              >
                ActiveX
              </a>{" "}
              activex merupakan framework microsoft yang dapat digunakan
              memanggil beragam aplikasi, atau control aktivitas yang ada pada
              microsoft. dengan memanfaatkan activex, attacker melakukan script
              memanggil <b>"WScript.Shell"</b> ? apa itu wscript shell, pada
              intinya wscriptshell merupakan objek pada windows yang digunakan
              untuk interaksi langsung dengan komponen sistem pada windows,
              bahkan registry.
            </p>
            <h2 className="font-PoppinsBold">How Attack Create Phising</h2>
            <p className="text text-justify pb-2">
              Yap, setelah kesimpulan diatas, js yang di set default on wsh,
              attacker melakukan javascript programming, dengan menggunakan
              activex - kemudian memanggil wscript.shell - dan mentrigger
              komponen sistem bahkan registry yang ada pada windows.
            </p>
            <b>POC</b>
            <br />
            1. Attacker Create this simpel script
            <br />
            <pre>
              var shell = new ActiveXObject("WScript.Shell")
              <br />
              var res = shell.Run("calc.exe");
            </pre>
            <p className="text text-justify pb-2">
              Sesuai mapping yang dilakukan attacker, attacker berhasil menspawn
              salah satu aplikasi pada windows yaitu cmd.exe
            </p>
            <img src={cals} className="img-fluid pb-1" alt="Responsive" />
            <br /> <br />
            <h2 className="font-PoppinsBold">
              Apakah bisa attacker escalate POC ?
            </h2>
            <p className="text text-justify pb-2">
              Yap, ketika phising berjalan, script akan melakukan exploitasi
              sesuai dengan attacker buat ? bayangkan jika attacker melakukan
              explorasi, dengan memanfaatkan javascript sebagai exploitasi
              mendapatkan hak akses terhadapa shell atau remote perangkat.
            </p>
            <p className="text text-justify pb-2">
              1. Attacker generate script revershell
              <br />
              <img src={generate} className="img-fluid pb-1" alt="Responsive" />
              <br />
              2. Attacker use javascript for fetch the exploit payload, and
              execute from js
              <br />
              <img src={server} className="img-fluid pb-1" alt="Responsive" />
              <br />
              3. Attacker set listener same with payload generated
              <br />
              <img src={listener} className="img-fluid pb-1" alt="Responsive" />
              <br />
              4. Attacker create js script (fetch the exploit, and trigger the
              exploit) <br />
              <img
                src={payload}
                className="img-fluid pb-1"
                alt="Responsive"
              />{" "}
              <br />
              5. victim download the js script (and run) <br />
              <img
                src={victim}
                className="img-fluid pb-1"
                alt="Responsive"
              />{" "}
              <br />
              6. the script success fetch the payload exploit <br />
              <img
                src={visit}
                className="img-fluid pb-1"
                alt="Responsive"
              />{" "}
              <br />
              7. Attacker get full access victim (korban) with shell <br />
              <img
                src={getshell}
                className="img-fluid pb-1"
                alt="Responsive"
              />{" "}
              <br />
            </p>
            <h2 className="font-PoppinsBold">Prevent ?</h2>
            <p className="text text-justify pb-2">
              Pada intinya, phising terjadi bukan karena kesalahan sistem
              sepenuhnya, phising terjadi karena korban melakukan kesalahan yang
              seharusnya tidak menjadi suatu default sistem, phising biasanya di
              combien dengan impersonate seseorang (untuk memainkan psikologi
              target), pada akhirnya pastikan kita sebagai user, tidak sembarang
              melakukan running / exekusi file, secara sembarang.
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default JsPhising;

